import {
  Button,
  Flex,
  Grid,
  IconAddLine,
  IconEditLine,
  List,
} from "@instructure/ui";
import { IconButton } from "@instructure/ui-buttons";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { AssignmentTypeService } from "../../services/AssignmentTypeService";
import { AssignmentTypeEditModal } from "./AssignmentTypeEditModal";

export const AssignmentTypePanel = ({ onAssignmentTypesReload }) => {
  const { t } = useTranslation();
  const [assignmentTypeList, setAssignmentTypeList] = useState([]);
  // const [assignmentTypeToRemove, setAssignmentTypeToRemove] = useState(null);
  const [editedType, setEditedType] = useState(null);
  const [reloadData, setReloadData] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (reloadData) {
      setLoading(true);
      AssignmentTypeService.getAssignmentTypes().then((assignmentTypes) => {
        setAssignmentTypeList(assignmentTypes);
        setReloadData(false);
        if (onAssignmentTypesReload) {
          onAssignmentTypesReload(assignmentTypes);
        }
        setLoading(false);
      });
    }
  }, [reloadData]);

  const handleEditClick = (type) => {
    setEditedType(type);
  };

  const addAssignmentType = () => {
    setEditedType({});
  };

  // const removeAssignmentType = async () => {
  //   await AssignmentTypeService.deleteAssignmentType(assignmentTypeToRemove.id)
  //     .then(() => {
  //       setAssignmentTypeToRemove(null);
  //       setReloadData(true);
  //       showNotification(t("notifications.assignmentType.deleteSuccess"));
  //     })
  //     .catch((e) => {
  //       showNotification(
  //         `${t("notifications.assignmentType.deleteError")} ${e}`,
  //         ERROR
  //       );
  //     });
  // };

  const handleEditModalClose = (updated) => {
    setEditedType(null);
    if (updated) {
      setReloadData(true);
    }
  };

  return (
    <>
      <Grid hAlign="end" vAlign="middle">
        <Grid.Row>
          <Grid.Col width="auto">
            <Button
              color="primary"
              onClick={addAssignmentType}
              renderIcon={IconAddLine}
              key={"attainment-add-button"}
            >
              {t("assignment.addAssignmentTypeButton")}
            </Button>
          </Grid.Col>
        </Grid.Row>
      </Grid>
      <div style={{ marginTop: 15 }}>
        {loading ? (
          <Skeleton count={3} style={{ marginBottom: 10, height: 60 }} />
        ) : (
          <>
            <List isUnstyled>
              {assignmentTypeList &&
                assignmentTypeList.map((type, key) => {
                  return (
                    <List.Item key={key}>
                      <div
                        style={{
                          backgroundColor: "#F2F8FA",
                          border: "1px solid #333",
                          borderRadius: "10px",
                          padding: "5px 15px",
                          marginBottom: 10,
                        }}
                      >
                        <Grid
                          vAlign="middle"
                          hAlign="space-between"
                          colSpacing="small"
                        >
                          <Grid.Row>
                            <Grid.Col width={10} hAlign="space-between">
                              <Flex>
                                <Flex.Item shouldGrow shouldShrink>
                                  <Flex direction="column">
                                    <Flex.Item>
                                      <span style={{ color: " #0D323F" }}>
                                        {type.name}
                                      </span>
                                    </Flex.Item>
                                    <Flex.Item>
                                      <span
                                        style={{
                                          fontSize: "0.9em",
                                          color: "#156380",
                                        }}
                                      >
                                        {type.description}
                                      </span>
                                    </Flex.Item>
                                  </Flex>
                                </Flex.Item>
                              </Flex>
                            </Grid.Col>
                            <Grid.Col width="auto">
                              <IconButton
                                shape="rectangle"
                                screenReaderLabel={t(
                                  "assignment.editTagScreenReaderLabel"
                                )}
                                margin="none small none none"
                                onClick={() => handleEditClick(type)}
                              >
                                <IconEditLine />
                              </IconButton>{" "}
                              {/*Commented out delete functionality below for IN-174 until assignment type deletion can be safely handled re existing assessment plan associations*/}
                              {/* <IconButton
                                shape="rectangle"
                                screenReaderLabel={t(
                                  "assignment.deleteTagScreenReaderLabel"
                                )}
                                onClick={() => setAssignmentTypeToRemove(type)}
                              >
                                <IconTrashLine />
                              </IconButton> */}
                            </Grid.Col>
                          </Grid.Row>
                        </Grid>
                      </div>
                    </List.Item>
                  );
                })}
            </List>{" "}
            {/*Commenting out the conditionals for the events below because delete functionality not in use, line 154 /*}
            {/* <DialogYesNo
            message={t("assignment.deleteAssignmentType")}
            openStatus={!!assignmentTypeToRemove}
            onClickNo={() => setAssignmentTypeToRemove(null)}
            onClickYes={removeAssignmentType}
          /> */}
          </>
        )}
      </div>
      {editedType && (
        <AssignmentTypeEditModal
          open={true}
          assignmentType={editedType}
          onCloseHandler={handleEditModalClose}
        />
      )}
    </>
  );
};
